<template>
  <div>
    <div class="mt-4 mx-2">
      <v-row class="mb-2">
        <v-col cols="12" md="4">
          <div :class="$vuetify.breakpoint.smAndDown?'text-subtitle-1 text-center':'text-h5 ml-3 float-left'" >
            Statistiche {{rangeString}}
          </div>
        </v-col>
        <v-col cols="12" md="8" :class="$vuetify.breakpoint.smAndDown?'text-center pb-3 pt-0':'float-right text-right pb-0'">
          <v-btn-toggle
            v-model="timeframeValue"
            mandatory
            active-class="info"
            @change="calculateTimeFrame(timeframeValue)"
          >
            <v-btn :small="$vuetify.breakpoint.smAndDown" :loading="loading" value="M">{{$vuetify.breakpoint.smAndDown?'1M':'Mese'}}</v-btn>
            <v-btn :small="$vuetify.breakpoint.smAndDown" :loading="loading" value="S">{{$vuetify.breakpoint.smAndDown?'6M':'Semestre'}}</v-btn>
            <v-btn :small="$vuetify.breakpoint.smAndDown" :loading="loading" value="Y">{{$vuetify.breakpoint.smAndDown?'1A':'Anno'}}</v-btn>
          </v-btn-toggle>
          <span class="ml-2">
            <v-btn :small="$vuetify.breakpoint.smAndDown" :loading="loading" :height="$vuetify.breakpoint.smAndDown?'':44" style="border:1px #444 solid" @click="monthdiff--;calculateTimeFrame(timeframeValue)"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <v-btn :small="$vuetify.breakpoint.smAndDown" :loading="loading" :height="$vuetify.breakpoint.smAndDown?'':44" style="border:1px #444 solid" @click="monthdiff++;calculateTimeFrame(timeframeValue)"><v-icon>mdi-chevron-right</v-icon></v-btn>        
            <v-btn :small="$vuetify.breakpoint.smAndDown" :loading="loading" :height="$vuetify.breakpoint.smAndDown?'':44" style="border:1px #444 solid" @click="dialog_range=true" class="ml-2"><v-icon>mdi-calendar</v-icon></v-btn>
          </span>
        </v-col>
      </v-row>
      <v-row>        
        <v-col cols="12" class="pt-0">
          <v-card 
            class="neu-glow ma-md-4 pa-md-4 ma-1 pa-1 overflow-auto"
            :height="Math.max(wHeight-200,650)"
          >         
            <v-row dense>
              <v-col cols="12"> 
                <v-row v-if="!charts||loading">
                  <v-col cols="12"> 
                    <v-card :height="Math.max(wHeight-248,620)" class="text-center pt-16">
                        <v-progress-circular
                          :size="wHeight-458"
                          width="35"
                          color="info"
                          indeterminate
                          class="pt-10"
                        ></v-progress-circular>
                    </v-card>
                  </v-col>
                </v-row>                         
                <v-row class="pa-4 mt-2" align="top" v-else>

                  <v-col cols="12" lg="4" class="pt-0 px-1 px-md-4 py-md-2 " v-for="(c,ci) in charts.filter(chart => chartsData.hasOwnProperty(chart.chartId))" :key="ci">
                    <v-card class="neu-glow px-4">
                      <v-card-title style="min-height:72px">
                        {{c.title}}
                        <v-spacer></v-spacer>
                        <v-tooltip top v-if="c.instructions">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="showInfoDialog(c)">
                              <v-icon color="info">mdi-information</v-icon>
                            </v-btn>
                          </template>
                          <span>Info</span>
                        </v-tooltip>
                      </v-card-title>
                      <template v-if="c.type=='line'">
                        <line-chart
                            :data="calcData(c.chartId)"
                            :options="other_settings.line_option"
                            :style="{ height: '400px' }"
                            class="pt-5"
                        />
                      </template>
                      <template v-if="c.type=='doughnut'">
                        <doughnut-chart
                            :data="calcData(c.chartId)"
                            :options="other_settings.doughnut_option"
                            :style="{ height: '400px' }"
                            :centerText="calcCT(c)"
                            :centerSubText="c.centerSubText"                            
                            class="pt-5"
                        />
                      </template>
                      <template v-if="c.type=='bar'">
                        <bar-chart
                            :data="calcData(c.chartId)"
                            :options="other_settings.bar_option"
                            :style="{ height: '400px' }"
                            class="pt-5"
                        />
                      </template>
                    </v-card>
                  </v-col>        
                </v-row>   

              </v-col>    
            </v-row>
          </v-card>
        </v-col> 
      </v-row>
    </div>
    <v-dialog
      v-model="dialog_range"
      persistent
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          Scegli Periodo
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_range=false;loadData('slots')">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4">
          <v-date-picker
            v-model="timeframe"
            scrollable
            range
            color="info"
            show-adjacent-months
            full-width
            :first-day-of-week="1"
            locale="it"
            show-week
          >
          </v-date-picker>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_info"
      v-if="charts&&activeChartId"
      width="600px"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title>
          {{charts.find(c=>c.chartId==activeChartId).title}}
          <v-spacer></v-spacer>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_info=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>           
        </v-card-title>
        <v-card class="neu-glow ma-4 pa-6">
          <span v-html="charts.find(c=>c.chartId==activeChartId).instructions"></span>
        </v-card>
      </v-card>
    </v-dialog>    
    <v-snackbar v-model="snackbar.active"
      top
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.text}}
    </v-snackbar>          
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import DoughnutChart from "@/components/ChartJS/DoughnutCharts";
  import LineChart from "@/components/ChartJS/LineChart";
  import BarChart from "@/components/ChartJS/BarChart";
  import colors from "vuetify/lib/util/colors";
  import _ from 'lodash'
  export default {
  components: { LineChart,DoughnutChart,BarChart},
  computed : {
    ...mapGetters(["user","settings","formattedTimeframe","other_settings"]),
    rangeString: function()
    {
      console.log(260,this.timeframe)
      const options={ year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(this.timeframe[0]).toLocaleDateString('it', options) + ' - ' + new Date(this.timeframe[1]).toLocaleDateString('it', options)
    }
  },    
  data() {
    return {     
      page: "Statistics",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_range:false,
      dialog_info:false,
      snackbar:{active:false,color:'success',text:''},      
      chartTitle:null,
      timeframeValue:null,
      chartType:null,
      monthdiff:0,
      form:{},
      chartsData:null,
      chartOptions:null,
      activeChartId:null,
      charts:null,
      loading: true,
      errorid: null,
      mediaQuery:null,
      //timeframe: [new Date().setMonth(new Date().getMonth()-1),new Date()],
      timeframe:[new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().substring(0, 10),new Date().toISOString().substring(0, 10)],
      timeframe_dialog: false,
      centerText:null,
      centerSubText:null,
      data:
      {
        labels: [],
        datasets: [{
            label: 'Prenotazioni',
            data: [],
            backgroundColor: [],
            borderWidth: 1
        }]
      },
    };
  },
  created(){
    console.log(333,this.timeframe);
    this.loadData('slots')
  },
  mounted() {
    this.mediaQuery = window.matchMedia("(orientation: portrait)");
    // Listen for changes
    this.mediaQuery.addEventListener("change", this.updateOrientation);
  },  
  methods:
  {
    updateOrientation(event) {
      //this.isPortrait = event.matches;
      this.wHeight=window.innerHeight;

    },    
    showInfoDialog(chart)
    {
      this.dialog_info=true;
      this.activeChartId=chart.chartId
      console.log(211,this.activeChartId)
    },
    calcCT(chart)
    {
      const vv=this.chartsData[chart.chartId].reduce((a, b) => a + b[chart.centerTextParameter], 0)
      console.log(231,chart,chart.centerSubText,vv)
      return vv
    },
    calcData(chartId)
    {
      //console.log(chartId)
      const lc=[[colors.red.base,colors.red.lighten3],[colors.pink.base,colors.pink.lighten3],[colors.purple.base,colors.purple.lighten3],[colors.indigo.base,colors.indigo.lighten3],[colors.blue.base,colors.blue.lighten3],[colors.cyan.base,colors.cyan.lighten3],[colors.teal.base,colors.teal.lighten3],[colors.green.base,colors.green.lighten3],[colors.lime.base,colors.lime.lighten3],[colors.yellow.base,colors.yellow.lighten3],[colors.amber.base,colors.amber.lighten3],[colors.orange.base,colors.orange.lighten3],[colors.brown.base,colors.brown.lighten3],[colors.red.lighten3,colors.red.darken3],[colors.pink.lighten3,colors.pink.darken3],[colors.purple.lighten3,colors.purple.darken3],[colors.indigo.lighten3,colors.indigo.darken3],[colors.blue.lighten3,colors.blue.darken3],[colors.cyan.lighten3,colors.cyan.darken3],[colors.teal.lighten3,colors.teal.darken3],[colors.green.lighten3,colors.green.darken3],[colors.lime.lighten3,colors.lime.darken3],[colors.yellow.lighten3,colors.yellow.darken3],[colors.amber.lighten3,colors.amber.darken3],[colors.orange.lighten3,colors.orange.darken3],[colors.brown.lighten3,colors.brown.darken3],[colors.grey.lighten3,colors.grey.darken3]];
      const bg2=[colors.red.base,colors.red.lighten3,colors.pink.base,colors.pink.lighten3,colors.purple.base,colors.purple.lighten3,colors.indigo.base,colors.indigo.lighten3,colors.blue.base,colors.blue.lighten3,colors.cyan.base,colors.cyan.lighten3,colors.teal.base,colors.teal.lighten3,colors.green.base,colors.green.lighten3,colors.lime.base,colors.lime.lighten3,colors.yellow.base,colors.yellow.lighten3,colors.amber.base,colors.amber.lighten3,colors.orange.base,colors.orange.lighten3,colors.brown.base,colors.brown.lighten3,colors.red.lighten3,colors.red.darken3,colors.pink.lighten3,colors.pink.darken3,colors.purple.lighten3,colors.purple.darken3,colors.indigo.lighten3,colors.indigo.darken3,colors.blue.lighten3,colors.blue.darken3,colors.cyan.lighten3,colors.cyan.darken3,colors.teal.lighten3,colors.teal.darken3,colors.green.lighten3,colors.green.darken3,colors.lime.lighten3,colors.lime.darken3,colors.yellow.lighten3,colors.yellow.darken3,colors.amber.lighten3,colors.amber.darken3,colors.orange.lighten3,colors.orange.darken3,colors.brown.lighten3,colors.brown.darken3,colors.grey.lighten3,colors.grey.darken3];
      const data=JSON.parse(JSON.stringify(this.data))
      const emptyDS={...this.other_settings.doughnut_empty_dataset};
      const chartData=this.chartsData[chartId]
      if(chartData)
      {
        const chartP=this.charts.find(c=>c.chartId==chartId)
        const enabled=chartP.enabled.split(',')
        const ctp=chartP.centerTextParameter;
        const centerText=chartData.reduce((a, b) => a + b[ctp], 0);
        //const centerSubText=chartP.centerSubText;
        const bg=chartP.bg||bg2;
        data.labels=chartData.map(a => a['label'])
        data.datasets=[];
        enabled.forEach( (e,i) =>
        {           
          //console.log(233,e,p,lc[i],lc[i][0])
          emptyDS.label=e;//e.charAt(0).toUpperCase() + e.slice;
          emptyDS.data = chartData.map(a => a[e])
          emptyDS.backgroundColor= bg;
          emptyDS.yAxisID=chartP.yAx&&chartP.yAx.includes(e)?2:1;
          if(chartId=='line')
            emptyDS.gradientStroke= lc[i];
          data.datasets.push(JSON.parse(JSON.stringify(emptyDS)));
        });
        this.centerText=centerText;
        //this.centerSubText=centerSubText; 
      }
      return data;
    },
    showChart(c)
    {
      console.log(193,c)
      this.chartTitle=c;
      this.loadData(c)
    },    
    calculateTimeFrame(t)
    {
      var r=null
      switch(t)
      {
        case 'W':
          r=(this.getM(0))
        break;
        case 'M':
          r=(this.getM(1))
        break;
        case 'S':
          r=(this.getM(6))
        break; 
        case 'Y':
          r=(this.getM(12))
        break;                
      }
      console.log(194,r)
      this.timeframe= r;
      this.showChart(this.chartType)
    },
    getM(m) {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();
        
        // Get the first and last day of the current month
        const firstDay = new Date(year, month - m + this.monthdiff, 1);
        const lastDay = new Date(year, month + this.monthdiff, 0);
        //console.log(224,firstDay,lastDay)
        // Format the dates to yyyy-mm-dd
        const formatDate = date => {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const dd = String(date.getDate()).padStart(2, '0');
            const r=`${yyyy}-${mm}-${dd}`;
            //console.log(230,yyyy,mm,dd,r)
            return r;
        };

        return [formatDate(firstDay), formatDate(lastDay)];
    },       
    async loadData(chart=''){
      this.loading=true;
      console.log(238,chart)
      let datasetscount=0;
      //try{
          const payload={"action":"statistics","timeframe":this.timeframe}
          const res = await this.$http.post('/stats/stats.php', payload );
          console.log(221,res)
          switch (res.data.errorid)
          {
            
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.centerSubText='Coperti';

              this.chartsData = res.data.payloads.data;
              this.charts=res.data.payloads.charts;
              
            break;
            case '001':
              //this.$router.push('/error/403').catch(() => {});
                this.snackbar.active=true;
                this.snackbar.text='No Data';
                this.snackbar.color="error"              
            break;
            case '0403':
              this.$router.push('/error/403').catch(() => {});
            break;
            case '0007':
              this.$router.push('/auth/login').catch(() => {});
            break;
            default:
              this.$router.push('/auth/login').catch(() => {});

          }
          console.log(259);       
      /*} catch(e)
      {
          this.loading= false;
          //console.log(res.data);
      }*/
      this.loading= false;
    }
  },
}
</script>